<template>
<div class="deposit">
  <deposit-card
    v-for="(item,index) in payTypeList"
    :key="index"
    :pay-item="item"
  ></deposit-card>
</div>
</template>

<script>
import { queryTPayType } from '@/api/userCenter'
import depositCard from "@/components/deposit/depositCard";
export default {
  name: "index",
  components:{
    depositCard,
  },
  data() {
    return {
      payTypeList: [],
    }
  },
  created(){
    this.getPayType();
  },
  methods: {
    getPayType(){
      queryTPayType({
        oprType: 1,
      }).then((res) => {
        this.payTypeList = res.data;
      })
    },
  },
}
</script>

<style lang="scss">
// 入金渠道card 和
.deposit {
  .deposit-card {
    background-color: #ffffff;
    border-radius: 10px;
    padding: 24px;
    margin-bottom: 20px;
    .title {
      font-size: 16px;
      font-weight: 600;
      margin-bottom: 20px;
      color: #5E5873;
    }
    .card-item {
      border-radius: 5px;
      border: 1px solid #EBE9F1;
      padding: 10px 15px;
      cursor: pointer;
      margin-bottom: 20px;
      .name {
        color: #5E5873;
      }
      &.nouser {
        background-color: #F8F8F8;
      }
      .card-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .top-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .icon-tips {
          color: #D85E5F;
        }
        .icon-img {
          width: 24px;
          height: 24px;
          margin-right: 10px;
        }
        .name {
          font-size: 16px;
          font-weight: 600;
        }
      }
      .bottom-line {
        padding-left: 34px;
        padding-top: 15px;
        color: #6E6B7B;
      }
    }
  }
}
</style>
